import React, { useEffect } from "react";

import { BrowserRouter, Routes, Route } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import "./App.scss";
import Home from "./components/Navbar/Home";
import AboutMe from "./container/About/AboutMe";
import Skill from "./container/About/Skill";
import Experience from "./container/About/Experience";
import SwiperSection from "./container/Work/SwiperSection";
import ProjectDetails from "./container/ProjectDetails/ProjectDetails";
import { SwiperSlide } from "swiper/react";
import About from "./container/About/About";
const App = () => {
  useEffect(() => {
    AOS.init({
      duration: 1300,
    });
    AOS.refresh();
  }, []);
  return (
    <div className="app">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />}>
            <Route path="/" element={<SwiperSection />} />
            <Route path="/home/work/webApp" element={<SwiperSection />} />
            <Route path="/home/work/mobileApp" element={<Skill />} />
            <Route path="/home/work/dApp" element={<Experience />} />
          </Route>
          <Route
            path="/projectDetails/:projectId"
            element={<ProjectDetails />}
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
};

export default App;
